import { apiClient } from '@/lib/api/client'

export type UserAvailabilityStatus = 'online' | 'break' | 'lunch' | 'offline'

export interface UpdateUserStatusResponse {
  success: boolean
  message?: string
  status: UserAvailabilityStatus
  status_changed_at: string | null
}

export const UserService = {
  /**
   * Update current user's availability status (online, break, lunch).
   */
  async updateStatus(status: UserAvailabilityStatus): Promise<UpdateUserStatusResponse> {
    const res = await apiClient.put<UpdateUserStatusResponse>('/user/status', { status })
    return res.data
  },
}
